// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Dashboard Welcome --- */
.dashboard-welcome h2 {
  font-size: 24px;
  font-weight: 600;
  color: #174078;
  margin: 0 0 24px 0;
}

/* --- Top Stats Grid --- */
.stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 2.1fr;
  gap: 24px;
  margin-bottom: 30px;
}

/* === GENERAL STAT CARD STYLES === */
.stat-card {
  height: 314px;
  border-radius: 16px;
  padding: 24px;
  border: none;
  box-sizing: border-box;
  position: relative;
}
.card-blue {
  background-color: #f0f6ff;
}
.card-orange {
  background-color: #fff4ec;
}

/* === ICON CONTAINER STYLES === */
.card-icon-bg {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
}
.card-blue .card-icon-bg {
  border: 1px solid #dbeafe;
}
.card-orange .card-icon-bg {
  border: 1px solid #ffeadd;
}
.card-icon-bg img {
  width: 24px;
  height: 24px;
}

/* === POSITIONING RULES FOR THE FIRST THREE CARDS' CONTENT === */
.stat-card:not(.transaction-card) .card-icon-bg {
  position: absolute;
  top: 24px;
  right: 24px;
}

/* === THE DEFINITIVE FIX: Reposition the Title to the MIDDLE-LEFT === */
.stat-card:not(.transaction-card) .card-title {
  position: absolute;
  top: 50%; /* CORRECT: Move to the vertical midpoint */
  left: 24px;
  transform: translateY(-50%); /* The vertical centering trick */
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.stat-card:not(.transaction-card) .card-value-row {
  position: absolute;
  bottom: 24px;
  left: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.card-value {
  font-size: 48px;
  font-weight: 700;
  margin: 0;
  line-height: 1;
}
.card-value
/* === THEMED COLOR STYLES === */
/* Default title color */
.card-title {
  color: #6b7280;
}
/* Blue Card Theming */
.card-blue .card-title,
.card-blue .card-value {
  color: #174078;
}

.card-blue .percentage-badge {
  background-color: #e3fff7;
  color: #00ba88;
  outline: 2px solid #00ba88;
}
/* Orange Card Theming */
.card-orange .card-title,
.card-orange .card-value {
  color: #ff6600;
}
.card-orange .percentage-badge {
  background-color: #ffe7e7;
  color: #eb3d40;
  outline: 2px solid #eb3d40;
}
/* General badge styling — anchored to the top-left of each card */
.stat-card:not(.transaction-card) .percentage-badge {
  position: absolute;
  top: 24px;
  left: 24px;
  font-size: 14px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
  line-height: 1;
}

/* --- Transaction Stat Card Specific Styles --- */
.stat-card.transaction-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.transaction-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}
.transaction-card-header .card-icon-bg {
  position: static;
  background-color: #ffeadd;
  border: none;
  width: 40px;
  height: 40px;
}
.transaction-card-header .card-icon-bg img {
  width: 20px;
  height: 20px;
}
.currency-toggle {
  border: 1px solid #fdba74;
  background: #fff;
  padding: 4px 10px;
  border-radius: 100px;
}
.currency-toggle button {
  border: 1px solid #fdba74;
  background: none;
  padding: 4px 12px;
  border-radius: 100px;
  border: none;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  color: #f97316;
}
.currency-toggle button:first-child {
  border-radius: 6px 0 0 6px;
}
.currency-toggle button:last-child {
  border-radius: 0 6px 6px 0;
}
.currency-toggle button.active {
  background-color: #fff3ea;
  border-radius: 100px;
}
.transaction-card .card-value {
  font-size: 36px;
}
.transaction-card .card-title {
  position: static;
  transform: none;
}

/* --- Main Content Grid --- */
.main-content-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
}

/* --- Recent Shipment Transaction Card --- */
.recent-transactions-card {
  background-color: #ffffff;
  border: 1px solid #f3f4f6;
  border-radius: 16px;
  padding: 25px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.card-header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}
.see-all-link {
  color: #f97316;
  font-weight: 600;
  text-decoration: none;
}
.transactions-tabs {
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 10px;
}
.transactions-tabs button {
  background: none;
  border: none;
  padding: 0 4px 12px 4px;
  margin-right: 25px;
  font-size: 16px;
  color: #6b7280;
  cursor: pointer;
  position: relative;
  border-bottom: 2px solid transparent;
}
.transactions-tabs button.active {
  color: #f97316;
  font-weight: 600;
  border-bottom-color: #f97316;
}
.transactions-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.transactions-list li {
  display: flex;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #f3f4f6;
}
.transactions-list li:last-child {
  border-bottom: none;
}
.tx-status-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  flex-shrink: 0;
}
.tx-status-icon img {
  width: 24px;
  height: 24px;
  filter: none;
}
.tx-status-icon.pending {
  background-color: #fffbeb;
}
.tx-status-icon.completed {
  background-color: #f0fdf4;
}
.tx-status-icon.failed {
  background-color: #fef2f4;
}
.tx-details {
  flex-grow: 1;
}
.tx-description {
  font-weight: 500;
  font-size: 16px;
  color: #111827;
  margin: 0 0 4px 0;
}
.tx-id {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}
.tx-info {
  text-align: right;
  color: #6b7280;
}
.tx-date {
  font-size: 14px;
  margin: 0 0 4px 0;
}
.tx-time {
  font-size: 12px;
  margin: 0;
}
.tx-amount {
  font-size: 18px;
  font-weight: 600;
  color: #1e3a8a;
  margin-left: auto;
  padding-left: 24px;
  min-width: 120px;
  text-align: right;
}

/* --- Shop4me Card --- */
.shop4me-card {
  height: 314px;
  background-color: #f0f6ff;
  position: relative;
}
.shop4me-card .card-icon-bg {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 48px;
  height: 48px;
  background-color: #ffffff;
  border: 1px solid #dbeafe;
}
.shop4me-card .card-icon-bg img {
  width: 24px;
  height: 24px;
}
.shop4me-card .card-title {
  position: absolute;
  top: 50%;
  left: 24px;
  transform: translateY(-50%);
  font-weight: 600;
  font-size: 20px;
  color: #174078;
  margin: 0;
}
.shop4me-card .card-value {
  position: absolute;
  bottom: 24px;
  left: 24px;
  font-size: 48px;
  font-weight: 700;
  color: #174078;
  margin: 0;
}

/* --- RESPONSIVENESS --- */
@media (max-width: 1200px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  .stat-card,
  .shop4me-card {
    height: 220px;
    position: relative;
  }
  .main-content-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}

@media (max-width: 768px) {
  /* 1. Stack all cards in a single column */
  .stats-grid {
    grid-template-columns: 1fr; /* Use a single column layout */
    gap: 16px;
  }

  /* 2. Style the three main stat cards (Shipments, Customers, etc.) */
  .stat-card:not(.transaction-card) {
    display: flex; /* Arrange icon and text content side-by-side */
    flex-direction: row; /* Ensure horizontal layout */
    justify-content: flex-start; /* Override desktop's space-between */
    align-items: center;
    padding: 16px;
    gap: 16px; /* Space between icon and text */
    min-height: auto; /* Remove the minimum height from desktop */
  }

  /* 3. Style the icon container within the card */
  .stat-card:not(.transaction-card) .card-icon-bg {
    flex-shrink: 0; /* Prevent the icon from shrinking */
    width: 48px;
    height: 48px;
    margin: 0;
  }

  /* 4. Style the text content wrapper */
  .stat-card:not(.transaction-card) .card-text-content {
    display: flex;
    flex-direction: column; /* Stack the title and the value/badge vertically */
    gap: 4px;
    flex-grow: 1; /* Allow it to take up the remaining space */
  }

  .stat-card:not(.transaction-card) .card-title {
    font-size: 14px;
    color: #6b7280; /* A more subdued title color */
    margin: 0;
  }
  .stat-card:not(.transaction-card) .percentage-badge {
    top: 16px;
    left: 16px;
    font-size: 12px;
    padding: 3px 8px;
  }

  /* 5. Style the row containing the big number and percentage */
  .stat-card:not(.transaction-card) .card-value-row {
    display: flex;
    align-items: baseline; /* Align the bottom of the number and text */
    gap: 8px;
  }

  .stat-card:not(.transaction-card) .card-value {
    font-size: 24px;
    line-height: 1;
    margin: 0;
  }

  /* 6. Adjust the "Total Transaction" card specifically */
  .transaction-card {
    padding: 16px;
  }
  .transaction-card .card-title {
    margin-top: 16px; /* Add some space above the title */
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,QAAQ,EAAE,2CAA2C;EACrD,UAAU;EACV,2BAA2B,EAAE,iCAAiC;EAC9D,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;AACA;;;;EAIE,cAAc;AAChB;AACA,sBAAsB;AACtB;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;AACA,wBAAwB;AACxB;;EAEE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;AACA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;EACA;;IAEE,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,0CAA0C;EAC1C;IACE,0BAA0B,EAAE,+BAA+B;IAC3D,SAAS;EACX;;EAEA,oEAAoE;EACpE;IACE,aAAa,EAAE,+CAA+C;IAC9D,mBAAmB,EAAE,6BAA6B;IAClD,2BAA2B,EAAE,qCAAqC;IAClE,mBAAmB;IACnB,aAAa;IACb,SAAS,EAAE,gCAAgC;IAC3C,gBAAgB,EAAE,2CAA2C;EAC/D;;EAEA,gDAAgD;EAChD;IACE,cAAc,EAAE,oCAAoC;IACpD,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;EAEA,sCAAsC;EACtC;IACE,aAAa;IACb,sBAAsB,EAAE,mDAAmD;IAC3E,QAAQ;IACR,YAAY,EAAE,4CAA4C;EAC5D;;EAEA;IACE,eAAe;IACf,cAAc,EAAE,+BAA+B;IAC/C,SAAS;EACX;EACA;IACE,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;;EAEA,8DAA8D;EAC9D;IACE,aAAa;IACb,qBAAqB,EAAE,4CAA4C;IACnE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,cAAc;IACd,SAAS;EACX;;EAEA,wDAAwD;EACxD;IACE,aAAa;EACf;EACA;IACE,gBAAgB,EAAE,mCAAmC;EACvD;AACF","sourcesContent":["/* --- Dashboard Welcome --- */\n.dashboard-welcome h2 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #174078;\n  margin: 0 0 24px 0;\n}\n\n/* --- Top Stats Grid --- */\n.stats-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 2.1fr;\n  gap: 24px;\n  margin-bottom: 30px;\n}\n\n/* === GENERAL STAT CARD STYLES === */\n.stat-card {\n  height: 314px;\n  border-radius: 16px;\n  padding: 24px;\n  border: none;\n  box-sizing: border-box;\n  position: relative;\n}\n.card-blue {\n  background-color: #f0f6ff;\n}\n.card-orange {\n  background-color: #fff4ec;\n}\n\n/* === ICON CONTAINER STYLES === */\n.card-icon-bg {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #ffffff;\n}\n.card-blue .card-icon-bg {\n  border: 1px solid #dbeafe;\n}\n.card-orange .card-icon-bg {\n  border: 1px solid #ffeadd;\n}\n.card-icon-bg img {\n  width: 24px;\n  height: 24px;\n}\n\n/* === POSITIONING RULES FOR THE FIRST THREE CARDS' CONTENT === */\n.stat-card:not(.transaction-card) .card-icon-bg {\n  position: absolute;\n  top: 24px;\n  right: 24px;\n}\n\n/* === THE DEFINITIVE FIX: Reposition the Title to the MIDDLE-LEFT === */\n.stat-card:not(.transaction-card) .card-title {\n  position: absolute;\n  top: 50%; /* CORRECT: Move to the vertical midpoint */\n  left: 24px;\n  transform: translateY(-50%); /* The vertical centering trick */\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.stat-card:not(.transaction-card) .card-value-row {\n  position: absolute;\n  bottom: 24px;\n  left: 24px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.card-value {\n  font-size: 48px;\n  font-weight: 700;\n  margin: 0;\n  line-height: 1;\n}\n.card-value\n/* === THEMED COLOR STYLES === */\n/* Default title color */\n.card-title {\n  color: #6b7280;\n}\n/* Blue Card Theming */\n.card-blue .card-title,\n.card-blue .card-value {\n  color: #174078;\n}\n\n.card-blue .percentage-badge {\n  background-color: #e3fff7;\n  color: #00ba88;\n  outline: 2px solid #00ba88;\n}\n/* Orange Card Theming */\n.card-orange .card-title,\n.card-orange .card-value {\n  color: #ff6600;\n}\n.card-orange .percentage-badge {\n  background-color: #ffe7e7;\n  color: #eb3d40;\n  outline: 2px solid #eb3d40;\n}\n/* General badge styling — anchored to the top-left of each card */\n.stat-card:not(.transaction-card) .percentage-badge {\n  position: absolute;\n  top: 24px;\n  left: 24px;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 12px;\n  line-height: 1;\n}\n\n/* --- Transaction Stat Card Specific Styles --- */\n.stat-card.transaction-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.transaction-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n}\n.transaction-card-header .card-icon-bg {\n  position: static;\n  background-color: #ffeadd;\n  border: none;\n  width: 40px;\n  height: 40px;\n}\n.transaction-card-header .card-icon-bg img {\n  width: 20px;\n  height: 20px;\n}\n.currency-toggle {\n  border: 1px solid #fdba74;\n  background: #fff;\n  padding: 4px 10px;\n  border-radius: 100px;\n}\n.currency-toggle button {\n  border: 1px solid #fdba74;\n  background: none;\n  padding: 4px 12px;\n  border-radius: 100px;\n  border: none;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  color: #f97316;\n}\n.currency-toggle button:first-child {\n  border-radius: 6px 0 0 6px;\n}\n.currency-toggle button:last-child {\n  border-radius: 0 6px 6px 0;\n}\n.currency-toggle button.active {\n  background-color: #fff3ea;\n  border-radius: 100px;\n}\n.transaction-card .card-value {\n  font-size: 36px;\n}\n.transaction-card .card-title {\n  position: static;\n  transform: none;\n}\n\n/* --- Main Content Grid --- */\n.main-content-grid {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 24px;\n}\n\n/* --- Recent Shipment Transaction Card --- */\n.recent-transactions-card {\n  background-color: #ffffff;\n  border: 1px solid #f3f4f6;\n  border-radius: 16px;\n  padding: 25px;\n}\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.card-header h4 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n}\n.see-all-link {\n  color: #f97316;\n  font-weight: 600;\n  text-decoration: none;\n}\n.transactions-tabs {\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 10px;\n}\n.transactions-tabs button {\n  background: none;\n  border: none;\n  padding: 0 4px 12px 4px;\n  margin-right: 25px;\n  font-size: 16px;\n  color: #6b7280;\n  cursor: pointer;\n  position: relative;\n  border-bottom: 2px solid transparent;\n}\n.transactions-tabs button.active {\n  color: #f97316;\n  font-weight: 600;\n  border-bottom-color: #f97316;\n}\n.transactions-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.transactions-list li {\n  display: flex;\n  align-items: center;\n  padding: 20px 0;\n  border-bottom: 1px solid #f3f4f6;\n}\n.transactions-list li:last-child {\n  border-bottom: none;\n}\n.tx-status-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 16px;\n  flex-shrink: 0;\n}\n.tx-status-icon img {\n  width: 24px;\n  height: 24px;\n  filter: none;\n}\n.tx-status-icon.pending {\n  background-color: #fffbeb;\n}\n.tx-status-icon.completed {\n  background-color: #f0fdf4;\n}\n.tx-status-icon.failed {\n  background-color: #fef2f4;\n}\n.tx-details {\n  flex-grow: 1;\n}\n.tx-description {\n  font-weight: 500;\n  font-size: 16px;\n  color: #111827;\n  margin: 0 0 4px 0;\n}\n.tx-id {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0;\n}\n.tx-info {\n  text-align: right;\n  color: #6b7280;\n}\n.tx-date {\n  font-size: 14px;\n  margin: 0 0 4px 0;\n}\n.tx-time {\n  font-size: 12px;\n  margin: 0;\n}\n.tx-amount {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1e3a8a;\n  margin-left: auto;\n  padding-left: 24px;\n  min-width: 120px;\n  text-align: right;\n}\n\n/* --- Shop4me Card --- */\n.shop4me-card {\n  height: 314px;\n  background-color: #f0f6ff;\n  position: relative;\n}\n.shop4me-card .card-icon-bg {\n  position: absolute;\n  top: 24px;\n  right: 24px;\n  width: 48px;\n  height: 48px;\n  background-color: #ffffff;\n  border: 1px solid #dbeafe;\n}\n.shop4me-card .card-icon-bg img {\n  width: 24px;\n  height: 24px;\n}\n.shop4me-card .card-title {\n  position: absolute;\n  top: 50%;\n  left: 24px;\n  transform: translateY(-50%);\n  font-weight: 600;\n  font-size: 20px;\n  color: #174078;\n  margin: 0;\n}\n.shop4me-card .card-value {\n  position: absolute;\n  bottom: 24px;\n  left: 24px;\n  font-size: 48px;\n  font-weight: 700;\n  color: #174078;\n  margin: 0;\n}\n\n/* --- RESPONSIVENESS --- */\n@media (max-width: 1200px) {\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n  }\n  .stat-card,\n  .shop4me-card {\n    height: 220px;\n    position: relative;\n  }\n  .main-content-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  /* 1. Stack all cards in a single column */\n  .stats-grid {\n    grid-template-columns: 1fr; /* Use a single column layout */\n    gap: 16px;\n  }\n\n  /* 2. Style the three main stat cards (Shipments, Customers, etc.) */\n  .stat-card:not(.transaction-card) {\n    display: flex; /* Arrange icon and text content side-by-side */\n    flex-direction: row; /* Ensure horizontal layout */\n    justify-content: flex-start; /* Override desktop's space-between */\n    align-items: center;\n    padding: 16px;\n    gap: 16px; /* Space between icon and text */\n    min-height: auto; /* Remove the minimum height from desktop */\n  }\n\n  /* 3. Style the icon container within the card */\n  .stat-card:not(.transaction-card) .card-icon-bg {\n    flex-shrink: 0; /* Prevent the icon from shrinking */\n    width: 48px;\n    height: 48px;\n    margin: 0;\n  }\n\n  /* 4. Style the text content wrapper */\n  .stat-card:not(.transaction-card) .card-text-content {\n    display: flex;\n    flex-direction: column; /* Stack the title and the value/badge vertically */\n    gap: 4px;\n    flex-grow: 1; /* Allow it to take up the remaining space */\n  }\n\n  .stat-card:not(.transaction-card) .card-title {\n    font-size: 14px;\n    color: #6b7280; /* A more subdued title color */\n    margin: 0;\n  }\n  .stat-card:not(.transaction-card) .percentage-badge {\n    top: 16px;\n    left: 16px;\n    font-size: 12px;\n    padding: 3px 8px;\n  }\n\n  /* 5. Style the row containing the big number and percentage */\n  .stat-card:not(.transaction-card) .card-value-row {\n    display: flex;\n    align-items: baseline; /* Align the bottom of the number and text */\n    gap: 8px;\n  }\n\n  .stat-card:not(.transaction-card) .card-value {\n    font-size: 24px;\n    line-height: 1;\n    margin: 0;\n  }\n\n  /* 6. Adjust the \"Total Transaction\" card specifically */\n  .transaction-card {\n    padding: 16px;\n  }\n  .transaction-card .card-title {\n    margin-top: 16px; /* Add some space above the title */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
